"use client"

import NextImage from "next/image"
import { ArticleTeaserHeading } from "@/components/ArticleTeaserHeading/ArticleTeaserHeading.component"
import { Link } from "@/components/Link/Link.component"
import { useImageConfiguration } from "@/contexts/image-configuration/image-configuration.context"
import type { ArticleContentModel } from "@/services/api/content/models/article-content-model.types"
import { imageLoader } from "@/utilities/image/image-loader"

type RelatedArticleTeaserProps = {
  readonly model: ArticleContentModel.RelatedArticle
}

export function RelatedArticleTeaser({
  model: { image, kicker, targetUrl, id, title },
}: RelatedArticleTeaserProps) {
  const { serverUrl } = useImageConfiguration()

  return (
    <article className="grid grid-cols-4 gap-x-2 gap-y-1 xl:grid-cols-6">
      <div className="col-span-1 empty:hidden">
        {image !== null ? (
          <Link
            className="relative row-span-full block aspect-3/2 w-full"
            href={targetUrl}
            trackingModel={{
              contentId: id.toString(),
              contentSource: null,
              contentType: "article-teaser",
            }}
            webviewArticle={{
              id: id.toString(),
            }}
          >
            <NextImage
              alt={image.alternativeText}
              className="bg-whisper object-cover"
              fill={true}
              loader={imageLoader(serverUrl)}
              sizes="172px"
              src={image.aspectRatio3By2}
            />
          </Link>
        ) : null}
      </div>
      <div className="col-span-3 xl:col-span-5">
        <Link
          className="block w-fit hover:underline"
          href={targetUrl}
          trackingModel={{
            contentId: id.toString(),
            contentSource: null,
            contentType: "article-teaser",
          }}
          webviewArticle={{
            id: id.toString(),
          }}
        >
          <ArticleTeaserHeading
            className="font-theme-heading-weight text-xl leading-[1.25]! sm:text-2xl"
            kickerClass="article-kicker"
            title={{ html: title, kicker, plainText: title }}
          />
        </Link>
      </div>
    </article>
  )
}
